import React, { useEffect, useState } from "react";
import "./bank-save-model.css";
import CommonDropdown from "../common/common_dropDown";
import { X } from "lucide-react";
import {
  getVendorBankDetApi,
  getVendorEditApi,
  getVendorGSTAttApi,
  getVendorMsmeAttApi,
  getVendorTaxDeApi,
  saveBankAPI,
  saveGSTAttachmentApi,
  saveMSMEAttachmentApi,
  saveTaxAPI,
} from "./vendor-api";
import { Spinner } from "react-bootstrap";

const BankTaxModal = ({ type, id, onClose, onSuccess }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const getFileNameFromUrl = (url) => {
    if (!url || typeof url !== "string") return "";
    return decodeURIComponent(url.split("/").pop().split("?")[0]);
  };
  const getFileExtensionFromUrl = (url) => {
    if (!url || typeof url !== "string") return "";
    const fileName = decodeURIComponent(url.split("/").pop().split("?")[0]);
    return fileName.includes(".")
      ? fileName.split(".").pop().toLowerCase()
      : "";
  };
  const [errorMsg, setErrorMsg] = useState({
    pan_number: "",
    tax_number: "",
    msme_number: "",
    tan_number: "",
    vat_number: "",
    tax_country_id: "",
    tax_type: "",
    currency_id: "",
    bank_name: "",
    holder_name: "",
    bank_account_number: "",
    ifsc_code: "",
    projects: "",
    notification_emails: "",
    gst_documents: "",
    msme_documents: "",
  });

  const [panNumber, setPanNumber] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [msmeNumber, setMsmeNumber] = useState("");
  const [tanNumber, setTanNumber] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [taxCountryOption, setTaxCountryOption] = useState(null);
  const [currencyOption, setCurrencyOption] = useState(null);
  const [taxTypeOption, setTaxTypeOption] = useState(null);
  const [bankName, setBankName] = useState("");
  const [holderName, setHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [gstDocuments, setGstDocuments] = useState([]);
  const [msmeDocuments, setMsmeDocuments] = useState([]);
  const [gstDocumentsUrl, setGstDocumentsUrl] = useState([]);
  const [msmeDocumentsUrl, setMsmeDocumentsUrl] = useState([]);
  const [removedGstDocuments, setRemovedGstDocuments] = useState([]);
  const [removedMsmeDocuments, setRemovedMsmeDocuments] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (id != null) {
      getVendorEdit(id);
    }
  }, [id]);

  const getVendorEdit = async (id) => {
    try {
      let response;
      let responsemsme;
      if (type === "Bank") {
        response = await getVendorBankDetApi(id);
      } else if (type === "Tax") {
        response = await getVendorTaxDeApi(id);
      } else {
        response = await getVendorGSTAttApi(id);
        responsemsme = await getVendorMsmeAttApi(id);
      }
      if (response.data.success === true) {
        const vendorDetail = response.data.details ?? {};

        if (type === "Bank") {
          setCurrencyOption(
            vendorDetail.currency_id
              ? {
                  value: vendorDetail.currency_id,
                  label: vendorDetail.currency ?? "",
                }
              : null,
          );
          setBankName(vendorDetail.bank_name ?? "");
          setHolderName(vendorDetail.holder_name ?? "");
          setAccountNumber(
            vendorDetail.bank_account_number ??
              vendorDetail.account_number ??
              "",
          );
          setIfscCode(vendorDetail.ifsc_code ?? "");
        } else if (type === "Tax") {
          setPanNumber(vendorDetail.pan_number ?? "");
          setGstNumber(
            vendorDetail.tax_number ?? vendorDetail.gst_number ?? "",
          );
          setMsmeNumber(vendorDetail.msme_number ?? "");
          setTanNumber(vendorDetail.tan_number ?? "");
          setVatNumber(vendorDetail.vat_number ?? "");
          setTaxCountryOption(
            vendorDetail.tax_country_id
              ? {
                  value: vendorDetail.tax_country_id,
                  label: vendorDetail.tax_country ?? "",
                }
              : null,
          );
          setTaxTypeOption(
            vendorDetail.tax_type
              ? {
                  value: vendorDetail.tax_type_id ?? vendorDetail.tax_type,
                  label: vendorDetail.tax_type ?? "",
                }
              : null,
          );
        } else {
          const vendorDetail = response.data.attachments ?? {};
          const vendorDetailMsme = responsemsme.data.attachments ?? {};
          setGstDocumentsUrl(vendorDetail ?? vendorDetail ?? []);
          setMsmeDocumentsUrl(vendorDetailMsme ?? vendorDetailMsme ?? []);
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handleSave = async () => {
    try {
      setSaving(true);
      setErrorMsg({}); // reset errors

      let payload;
      let gstPayload;
      let msmePayload;
      // ---------------- BANK ----------------
      if (type === "Bank") {
        payload = {
          ...payload,
          currency_id: currencyOption?.value ?? null,
          bank_name: bankName,
          holder_name: holderName,
          bank_account_number: accountNumber,
          ifsc_code: ifscCode,
        };
      }

      // ---------------- TAX ----------------
      if (type === "Tax") {
        payload = {
          ...payload,
          pan_number: panNumber,
          tax_number: gstNumber,
          vat_number: vatNumber,
          tan_number: tanNumber,
          msme_number: msmeNumber,
          tax_country_id: taxCountryOption?.value ?? null,
          tax_type: taxTypeOption?.value ?? null,
        };
      }

      // ---------------- ATTACHMENTS ----------------
      if (type === "Attach") {
        gstPayload = {
          attachments: gstDocuments
            .filter((doc) => doc.data && !doc.file)
            .map((doc) => ({
              file_name: doc.name,
              base64: doc.data,
            })),

          removed_attachments: removedGstDocuments,
        };
        msmePayload = {
          attachments: msmeDocuments
            .filter((doc) => doc.data && !doc.file)
            .map((doc) => ({
              file_name: doc.name,
              base64: doc.data,
            })),
          removed_attachments: removedMsmeDocuments,
        };
      }

      let response;
      let responsemsme;
      if (type === "Tax") {
        response = await saveTaxAPI(id, payload);
      } else if (type === "Bank") {
        response = await saveBankAPI(id, payload);
      } else {
        const hasGstChanges = gstPayload.attachments.length > 0 || gstPayload.removed_attachments.length > 0;
        const hasMsmeChanges = msmePayload.attachments.length > 0 || msmePayload.removed_attachments.length > 0;

        if (hasGstChanges) {
          response = await saveGSTAttachmentApi(id, gstPayload);
        } else {
          response = { data: { success: true } };
        }

        if (hasMsmeChanges) {
          responsemsme = await saveMSMEAttachmentApi(id, msmePayload);
        } else {
          responsemsme = { data: { success: true } };
        }
      }

      if (type === "Tax" || type === "Bank") {
        if (response?.data?.success) {
          onSuccess(response); // close modal
        } else {
          setErrorMsg(response?.data?.errors ?? {});
        }
      } else {
        if (response?.data?.success && responsemsme?.data?.success) {
          onSuccess(response); // close modal
        } else {
          const errors = {
            ...(response?.data?.errors ?? {}),
            ...(responsemsme?.data?.errors ?? {}),
          };
          setErrorMsg(errors);
        }
      }
    } catch (error) {
      console.error("Save failed:", error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        {/* Header */}
        <div className="modal-header">
          <h3>Bank & Tax Info</h3>
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Form */}
        <div className="form-grid">
          {type === "Tax" && (
            <div className="form-group">
              <label>Tax Country</label>
              <div className="w-100">
                <CommonDropdown
                  apiUrl={`${adminUrl}get_country`}
                  placeholder="Select"
                  value={taxCountryOption}
                  onSelect={(item) => {
                    setTaxCountryOption(item);
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.tax_country_id}
                </span>
              </div>
            </div>
          )}

          {type === "Bank" && (
            <div className="form-group">
              <label>Currency</label>
              <div className="w-100">
                <CommonDropdown
                  apiUrl={`${apiUrl}get_currency`}
                  placeholder="Select"
                  value={currencyOption}
                  onSelect={(item) => {
                    setCurrencyOption(item);
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.currency_id}
                </span>
              </div>
            </div>
          )}

          {type === "Tax" && (
            <div className="form-group">
              <label>Tax Type</label>
              <div className="w-100">
                <CommonDropdown
                  apiUrl={`${apiUrl}get_tax_types`}
                  placeholder="Select"
                  value={taxTypeOption}
                  onSelect={(item) => {
                    console.log({ item });
                    setTaxTypeOption(item);
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.tax_type}
                </span>
              </div>
            </div>
          )}

          {type === "Tax" && (
            <div className="form-group">
              <label>GST Number</label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control rounded-3 vendor-form-input"
                  id="gstNumberBank"
                  placeholder="Enter here..."
                  maxLength={15}
                  value={gstNumber}
                  onChange={(e) => {
                    setGstNumber(e.target.value.toUpperCase());
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.tax_number}
                </span>
              </div>
            </div>
          )}
          {type === "Tax" && (
            <div className="form-group">
              <label>VAT Number</label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control rounded-3 vendor-form-input"
                  id="vatNumberBank"
                  placeholder="Enter here..."
                  value={vatNumber}
                  onChange={(e) => {
                    setVatNumber(e.target.value);
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.vat_number}
                </span>
              </div>
            </div>
          )}

          {type === "Tax" && (
            <div className="form-group">
              <label>TAN Number</label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control rounded-3 vendor-form-input"
                  id="tanNumberBank"
                  placeholder="Enter here..."
                  maxLength={10}
                  value={tanNumber}
                  onChange={(e) => {
                    setTanNumber(e.target.value.toUpperCase());
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.tan_number}
                </span>
              </div>
            </div>
          )}

          {type === "Bank" && (
            <div className="form-group">
              <label>Bank Name</label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control rounded-3 vendor-form-input"
                  id="bankName"
                  placeholder="Enter bank name"
                  value={bankName}
                  onChange={(e) => {
                    setBankName(e.target.value);
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.bank_name}
                </span>
              </div>
            </div>
          )}

          {type === "Bank" && (
            <div className="form-group">
              <label>Holder name</label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control rounded-3 vendor-form-input"
                  id="holderName"
                  placeholder="Enter holder name"
                  value={holderName}
                  onChange={(e) => {
                    setHolderName(e.target.value);
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.holder_name}
                </span>
              </div>
            </div>
          )}

          {type === "Bank" && (
            <div className="form-group">
              <label>Account Number</label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control rounded-3 vendor-form-input"
                  id="accountNumber"
                  placeholder="Enter here..."
                  maxLength={30}
                  value={accountNumber}
                  onChange={(e) => {
                    setAccountNumber(e.target.value.replace(/\D/g, ""));
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/^\d$/.test(e.key) &&
                      !["Backspace", "Tab", "Delete", "ArrowLeft", "ArrowRight", "Enter"].includes(e.key) &&
                      !e.ctrlKey &&
                      !e.metaKey
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.bank_account_number}
                </span>
              </div>
            </div>
          )}

          {type === "Bank" && (
            <div className="form-group">
              <label>IFSC Code</label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control rounded-3 vendor-form-input"
                  id="ifscCode"
                  placeholder="Enter"
                  maxLength={11}
                  value={ifscCode}
                  onChange={(e) => {
                    setIfscCode(e.target.value.toUpperCase().slice(0, 11));
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.ifsc_code}
                </span>
              </div>
            </div>
          )}

          {type === "Tax" && (
            <div className="form-group">
              <label>PAN</label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control rounded-3 vendor-form-input"
                  id="panNumberBank"
                  placeholder="Enter here..."
                  maxLength={10}
                  value={panNumber}
                  onChange={(e) => {
                    setPanNumber(e.target.value.toUpperCase());
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.pan_number}
                </span>
              </div>
            </div>
          )}

          {type === "Tax" && (
            <div className="form-group">
              <label>MSME Number</label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control rounded-3 vendor-form-input"
                  id="msmeNumber"
                  placeholder="Enter MSME Number"
                  value={msmeNumber}
                  onChange={(e) => {
                    setMsmeNumber(e.target.value);
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.msme_number}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Documents */}
        {type === "Attach" && (
          <div className="document-grid">
            <div>
              <div className="col-md-12 col-6 mt-4">
                <p className="fs-16 fw-600 mb-3">GST Documents</p>
                <div
                  style={{
                    border: "1px dashed #E5E7EB",
                    borderRadius: "12px",
                    // padding: "40px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => document.getElementById("gstDocInput").click()}
                >
                  <div className="upload-container">
                    <div className="upload-content">
                      {/* Icon */}
                      <div className="upload-icon">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6B7280"
                          strokeWidth="1.5"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="12" y1="14" x2="12" y2="10" />
                          <line x1="10" y1="12" x2="14" y2="12" />
                        </svg>
                      </div>

                      {/* Text */}
                      <div className="upload-text">
                        <span>Drag and drop a PDF file here or</span>
                        <a
                          style={{
                            color: "#2563eb",
                            textDecoration: "underline",
                            fontWeight: "500",
                            cursor: "pointer",
                          }}
                        >
                          Choose from files
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <input
                  id="gstDocInput"
                  type="file"
                  accept=".pdf"
                  multiple
                  className="d-none"
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      const files = Array.from(e.target.files);
                      const promises = files.map((file) => {
                        return new Promise((resolve) => {
                          const reader = new FileReader();
                          reader.onload = () => {
                            resolve({
                              name: file.name,
                              data: reader.result,
                              size: file.size,
                            });
                          };
                          reader.readAsDataURL(file);
                        });
                      });
                      Promise.all(promises).then((results) => {
                        setGstDocuments([...gstDocuments, ...results]);
                      });
                    }
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.gst_documents}
                </span>
                {gstDocumentsUrl.length > 0 && (
                  <div className="mt-3">
                    {gstDocumentsUrl.map((doc, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between p-2 mb-2"
                        style={{
                          backgroundColor: "#F9FAFB",
                          borderRadius: "8px",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="#DC2626"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" fill="#DC2626" />
                          </svg>
                          <div>
                            <div
                              style={{ fontSize: "14px", fontWeight: "500" }}
                            >
                              {doc.file_name ?? getFileNameFromUrl(doc.file)}
                            </div>
                          </div>
                        </div>
                        <X
                          size={20}
                          style={{ cursor: "pointer", color: "#DC2626" }}
                          onClick={() => {
                            const newDocs = gstDocumentsUrl.filter(
                              (_, i) => i !== index,
                            );
                            setGstDocumentsUrl(newDocs);
                            if (doc.id) {
                              setRemovedGstDocuments([
                                ...removedGstDocuments,
                                doc.id,
                              ]);
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {gstDocuments.length > 0 && (
                  <div className="mt-3">
                    {gstDocuments.map((doc, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between p-2 mb-2"
                        style={{
                          backgroundColor: "#F9FAFB",
                          borderRadius: "8px",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="#DC2626"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" fill="#DC2626" />
                          </svg>
                          <div>
                            <div
                              style={{ fontSize: "14px", fontWeight: "500" }}
                            >
                              {getFileNameFromUrl(doc.name)}
                            </div>
                          </div>
                        </div>
                        <X
                          size={20}
                          style={{ cursor: "pointer", color: "#DC2626" }}
                          onClick={() => {
                            const newDocs = gstDocuments.filter(
                              (_, i) => i !== index,
                            );
                            setGstDocuments(newDocs);
                            if (doc.id) {
                              setRemovedGstDocuments([
                                ...removedMsmeDocuments,
                                doc.id,
                              ]);
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div>
              <div className="col-md-12 col-6 mt-4">
                <p className="fs-16 fw-600 mb-3">MSME Documents</p>
                <div
                  style={{
                    border: "1px dashed #E5E7EB",
                    borderRadius: "12px",
                    // padding: "40px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    document.getElementById("msmeDocInput").click()
                  }
                >
                  <div className="upload-container">
                    <div className="upload-content">
                      {/* Icon */}
                      <div className="upload-icon">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6B7280"
                          strokeWidth="1.5"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="12" y1="14" x2="12" y2="10" />
                          <line x1="10" y1="12" x2="14" y2="12" />
                        </svg>
                      </div>

                      {/* Text */}
                      <div className="upload-text">
                        <span>Drag and drop a PDF file here or</span>
                        <a
                          style={{
                            color: "#2563eb",
                            textDecoration: "underline",
                            fontWeight: "500",
                            cursor: "pointer",
                          }}
                        >
                          Choose from files
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <input
                  id="msmeDocInput"
                  type="file"
                  accept=".pdf"
                  multiple
                  className="d-none"
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      const files = Array.from(e.target.files);
                      const promises = files.map((file) => {
                        return new Promise((resolve) => {
                          const reader = new FileReader();
                          reader.onload = () => {
                            resolve({
                              name: file.name,
                              data: reader.result,
                              size: file.size,
                            });
                          };
                          reader.readAsDataURL(file);
                        });
                      });
                      Promise.all(promises).then((results) => {
                        setMsmeDocuments([...msmeDocuments, ...results]);
                      });
                    }
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "4px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.msme_documents}
                </span>
                {msmeDocumentsUrl.length > 0 && (
                  <div className="mt-3">
                    {msmeDocumentsUrl.map((doc, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between p-2 mb-2"
                        style={{
                          backgroundColor: "#F9FAFB",
                          borderRadius: "8px",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="#DC2626"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" fill="#DC2626" />
                          </svg>
                          <div>
                            <div
                              style={{ fontSize: "14px", fontWeight: "500" }}
                            >
                              {doc.file_name ?? getFileNameFromUrl(doc.file)}
                            </div>
                          </div>
                        </div>
                        <X
                          size={20}
                          style={{ cursor: "pointer", color: "#DC2626" }}
                          onClick={() => {
                            const newDocs = msmeDocumentsUrl.filter(
                              (_, i) => i !== index,
                            );
                            setMsmeDocumentsUrl(newDocs);
                            if (doc.id) {
                              setRemovedMsmeDocuments([
                                ...removedMsmeDocuments,
                                doc.id,
                              ]);
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {msmeDocuments.length > 0 && (
                  <div className="mt-3">
                    {msmeDocuments.map((doc, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between p-2 mb-2"
                        style={{
                          backgroundColor: "#F9FAFB",
                          borderRadius: "8px",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="#DC2626"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" fill="#DC2626" />
                          </svg>
                          <div>
                            <div
                              style={{ fontSize: "14px", fontWeight: "500" }}
                            >
                              {getFileNameFromUrl(doc.name)}
                            </div>
                          </div>
                        </div>
                        <X
                          size={20}
                          style={{ cursor: "pointer", color: "#DC2626" }}
                          onClick={() => {
                            const newDocs = msmeDocuments.filter(
                              (_, i) => i !== index,
                            );
                            setMsmeDocuments(newDocs);
                            if (doc.id) {
                              setRemovedMsmeDocuments([
                                ...removedMsmeDocuments,
                                doc.id,
                              ]);
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="modal-footer">
          <button className="btn-outline" onClick={onClose}>
            Cancel
          </button>

          <button
            className="btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? <Spinner animation="border" size="sm" /> : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BankTaxModal;
